import { Icon } from "@zapier/zinnia-icons";
import { Link, Text } from "@zapier/design-system";
import styles from "./BreadCrumbs.module.css";
import { Fragment } from "react";

export type BreadCrumbItem = {
  text: string;
  href?: string;
};

export function BreadCrumbs(props: { crumbs: BreadCrumbItem[] }) {
  return (
    <div className={styles.wrapper}>
      {props.crumbs.map((crumb, i) => (
        <Fragment key={i}>
          <BreadCrumb crumb={crumb} />
          {i < props.crumbs.length - 1 && (
            <Icon name="arrowSmallRight" size={24} color="GrayWarm6" />
          )}
        </Fragment>
      ))}
    </div>
  );
}

export function BreadCrumb(props: { crumb: BreadCrumbItem }) {
  const renderBody = () => {
    if (props.crumb.href) {
      return (
        <Text type="Body3">
          <Link href={props.crumb.href}>{props.crumb.text}</Link>
        </Text>
      );
    } else {
      return (
        <Text type="Body4" className={styles.crumbText}>
          {props.crumb.text}
        </Text>
      );
    }
  };

  return <div className={styles.crumbItem}>{renderBody()}</div>;
}
